import { Balance } from '../../../Balance/Balance';
import styles from './AccountBalance.module.scss';

export const AccountBalance = () => (
    <span className={styles['container']}>
        <Balance />
    </span>
);
